const DB_NAME = 'YuyuanVideoSubmissions'
let opening

function database() {
  if (!opening) opening = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1)
    request.onupgradeneeded = () => {
      for (const name of ['tasks', 'files', 'leases']) request.result.createObjectStore(name, { keyPath: 'id' })
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => { opening = null; reject(request.error) }
  })
  return opening
}

export async function transact(names, action) {
  const db = await database()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(names, 'readwrite')
    let result
    tx.oncomplete = () => resolve(result)
    tx.onerror = () => reject(tx.error)
    tx.onabort = () => reject(tx.error || new Error('本地任务保存失败'))
    action(tx, value => { result = value })
  })
}

export const putSubmission = task => transact(['tasks'], tx => tx.objectStore('tasks').put(task))
export const readSubmissionFiles = id => transact(['files'], (tx, done) => {
  tx.objectStore('files').get(id).onsuccess = event => done(event.target.result)
})
export const putSubmissionFile = file => transact(['files'], tx => tx.objectStore('files').put(file))
export const listSubmissions = () => transact(['tasks'], (tx, done) => {
  tx.objectStore('tasks').getAll().onsuccess = event => done(event.target.result)
})

// Atomic IndexedDB lease also works in browsers without Web Locks.
export const claimSubmissionWorker = (id, owner, release = false) => transact(['leases'], (tx, done) => {
  const store = tx.objectStore('leases')
  store.get(id).onsuccess = event => {
    const previous = event.target.result
    if (previous && previous.owner !== owner && previous.until > Date.now()) return done(false)
    if (release) store.delete(id)
    else store.put({ id, owner, until: Date.now() + 30000 })
    done(true)
  }
})

export async function saveSubmissionBatch(tasks, files) {
  await transact(['tasks', 'files'], tx => {
    tasks.forEach(task => tx.objectStore('tasks').put(task))
    files.forEach(file => tx.objectStore('files').put(file))
  })
}

export async function cleanSubmissionFiles() {
  await transact(['tasks', 'files'], tx => {
    tx.objectStore('tasks').getAll().onsuccess = event => {
      const tasks = event.target.result
      const referenced = new Set(tasks.filter(t => !['SUBMITTED', 'CANCELLED'].includes(t.state))
        .flatMap(t => t.references.map(r => r.fileId).filter(Boolean)))
      tx.objectStore('files').openCursor().onsuccess = e => {
        const cursor = e.target.result
        if (!cursor) return
        if (!referenced.has(cursor.key)) cursor.delete()
        cursor.continue()
      }
    }
  })
}
